import styled from "styled-components";

export const LayoutContainer = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100vh;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 30px 1fr;
    .outlet {
      position: absolute;
      z-index: 2000;
      top: 84px;
      left: 16px;
    }
    .leaflet-control-scale {
      margin: 0;
      bottom: 16px;
      left: 16px;
    }
    .leaflet-control-zoom {
      margin: 0;
      right: 14px;
      bottom: 112px;
      display: flex;
      flex-direction: column;
      gap: ${({ theme }) => theme.spacing}px;
      border: unset;
      a {
        border-radius: ${({ theme }) => theme.radius}px !important;
        box-shadow: ${({ theme }) => theme.boxShadow};
        border-top-left-radius: unset;
        border-top-right-radius: unset;
        border-bottom-left-radius: unset;
        border-bottom-right-radius: unset;
      }
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 30px 1fr;
    background-color: red;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

export const Container = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: 452px 1fr;
    height: 100%;
    .wrapper {
      position: relative;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
    background-color: green;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 144px 1fr;
  }
`;

export const Wrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    overflow-y: hidden;
    padding: ${({ theme }) => theme.spacing * 4}px;
    background-color: ${({ theme }) => theme.colors.gray[100]};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing * 4}px;
    .header {
      display: flex;
      flex-direction: column;
      gap: ${({ theme }) => theme.spacing * 4}px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 52px;
  }
`;

export const ModalContainer = styled.div`
  padding: 0 ${({ theme }) => theme.spacing * 4}px;
  > p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`;
